import { OrganizationList } from '../../organizations/components/OrganizationList';
import { PrejimkaMenu } from '../../prejimka/prejimkamenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const PrejimkaOrganizationListPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.prejimka ? (
        <AppWrapper
          appType={APP_TYPE.PREJIMKA}
          menu={<PrejimkaMenu />}
          resource='Organizations'
          action='list.view'
        >
          <OrganizationList />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default PrejimkaOrganizationListPage;
